module.exports = __webpack_public_path__ + "media/images/lb/448-17242b4bed3bd6aa4513f58afc0a97b6.svg";